import contractEditComponent from './contract.edit.component';
import printHistoryModule from './print';

let contractEditModule = angular.module('contractedit', [printHistoryModule])

    .component('contractedit', contractEditComponent)

    .name;

export default contractEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract/edit/index.js